module.exports = __webpack_public_path__ + "img/6.7818765e.jpg";